import Entity from '../entity';
export default class Balance extends Entity<string> {
  agencyId: string;
  creditLimit: number;


}
